import { MenuExternalVideo } from '@components/utility/richTexts/extensions';
import {
    MenuButtonBold,
    MenuButtonEditLink,
    MenuButtonImageUpload,
    MenuButtonImageUploadProps,
    MenuButtonItalic,
    MenuButtonOrderedList,
    MenuButtonRedo,
    MenuButtonUnderline,
    MenuButtonUndo,
    MenuControlsContainer,
    MenuSelectFontSize,
    MenuSelectHeading,
    MenuSelectTextAlign,
} from 'mui-tiptap';

type RichTextEditorControlsProps = {
    onUploadFiles?: MenuButtonImageUploadProps['onUploadFiles'];
};

const RichTextEditorControls = ({ onUploadFiles }: RichTextEditorControlsProps) => (
    <MenuControlsContainer className="w-max">
        <MenuButtonBold />
        <MenuButtonItalic />
        <MenuButtonUnderline />
        <MenuSelectFontSize />
        <MenuSelectTextAlign />
        <MenuButtonOrderedList />
        <MenuButtonEditLink />
        {onUploadFiles ? <MenuButtonImageUpload onUploadFiles={onUploadFiles} /> : null}
        <MenuExternalVideo />
        <MenuSelectHeading />
        <MenuButtonUndo />
        <MenuButtonRedo />
    </MenuControlsContainer>
);

export { RichTextEditorControls };
